// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";

// Import and reexport all reducer arg types
import { Attack } from "./attack_reducer.ts";
export { Attack };
import { ClientConnected } from "./client_connected_reducer.ts";
export { ClientConnected };
import { ClientDisconnected } from "./client_disconnected_reducer.ts";
export { ClientDisconnected };
import { CreateWorld } from "./create_world_reducer.ts";
export { CreateWorld };
import { DamageBlock } from "./damage_block_reducer.ts";
export { DamageBlock };
import { DamageEnemy } from "./damage_enemy_reducer.ts";
export { DamageEnemy };
import { DamagePlayer } from "./damage_player_reducer.ts";
export { DamagePlayer };
import { EnemyShootAtClosestPlayer } from "./enemy_shoot_at_closest_player_reducer.ts";
export { EnemyShootAtClosestPlayer };
import { InitEnemyTypes } from "./init_enemy_types_reducer.ts";
export { InitEnemyTypes };
import { MoveEnemyTowardCore } from "./move_enemy_toward_core_reducer.ts";
export { MoveEnemyTowardCore };
import { MovePlayer } from "./move_player_reducer.ts";
export { MovePlayer };
import { PlaceBlock } from "./place_block_reducer.ts";
export { PlaceBlock };
import { SpawnEnemy } from "./spawn_enemy_reducer.ts";
export { SpawnEnemy };
import { UpdateAttack } from "./update_attack_reducer.ts";
export { UpdateAttack };
import { UpdateWorldTick } from "./update_world_tick_reducer.ts";
export { UpdateWorldTick };

// Import and reexport all table handle types
import { BlockTableHandle } from "./block_table.ts";
export { BlockTableHandle };
import { EnemyTableHandle } from "./enemy_table.ts";
export { EnemyTableHandle };
import { EnemyTypeTableHandle } from "./enemy_type_table.ts";
export { EnemyTypeTableHandle };
import { PlayerTableHandle } from "./player_table.ts";
export { PlayerTableHandle };
import { WorldTableHandle } from "./world_table.ts";
export { WorldTableHandle };
import { WorldTickUpdateTimerTableHandle } from "./world_tick_update_timer_table.ts";
export { WorldTickUpdateTimerTableHandle };

// Import and reexport all types
import { Block } from "./block_type.ts";
export { Block };
import { Enemy } from "./enemy_type.ts";
export { Enemy };
import { EnemyType } from "./enemy_type_type.ts";
export { EnemyType };
import { Player } from "./player_type.ts";
export { Player };
import { ProjectileInfo } from "./projectile_info_type.ts";
export { ProjectileInfo };
import { World } from "./world_type.ts";
export { World };
import { WorldTickUpdateTimer } from "./world_tick_update_timer_type.ts";
export { WorldTickUpdateTimer };

const REMOTE_MODULE = {
  tables: {
    Block: {
      tableName: "Block",
      rowType: Block.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Block.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    Enemy: {
      tableName: "Enemy",
      rowType: Enemy.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Enemy.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    EnemyType: {
      tableName: "EnemyType",
      rowType: EnemyType.getTypeScriptAlgebraicType(),
      primaryKey: "typeId",
      primaryKeyInfo: {
        colName: "typeId",
        colType: EnemyType.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    Player: {
      tableName: "Player",
      rowType: Player.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Player.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    World: {
      tableName: "World",
      rowType: World.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: World.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    WorldTickUpdateTimer: {
      tableName: "WorldTickUpdateTimer",
      rowType: WorldTickUpdateTimer.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: WorldTickUpdateTimer.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
  },
  reducers: {
    Attack: {
      reducerName: "Attack",
      argsType: Attack.getTypeScriptAlgebraicType(),
    },
    ClientConnected: {
      reducerName: "ClientConnected",
      argsType: ClientConnected.getTypeScriptAlgebraicType(),
    },
    ClientDisconnected: {
      reducerName: "ClientDisconnected",
      argsType: ClientDisconnected.getTypeScriptAlgebraicType(),
    },
    CreateWorld: {
      reducerName: "CreateWorld",
      argsType: CreateWorld.getTypeScriptAlgebraicType(),
    },
    DamageBlock: {
      reducerName: "DamageBlock",
      argsType: DamageBlock.getTypeScriptAlgebraicType(),
    },
    DamageEnemy: {
      reducerName: "DamageEnemy",
      argsType: DamageEnemy.getTypeScriptAlgebraicType(),
    },
    DamagePlayer: {
      reducerName: "DamagePlayer",
      argsType: DamagePlayer.getTypeScriptAlgebraicType(),
    },
    EnemyShootAtClosestPlayer: {
      reducerName: "EnemyShootAtClosestPlayer",
      argsType: EnemyShootAtClosestPlayer.getTypeScriptAlgebraicType(),
    },
    InitEnemyTypes: {
      reducerName: "InitEnemyTypes",
      argsType: InitEnemyTypes.getTypeScriptAlgebraicType(),
    },
    MoveEnemyTowardCore: {
      reducerName: "MoveEnemyTowardCore",
      argsType: MoveEnemyTowardCore.getTypeScriptAlgebraicType(),
    },
    MovePlayer: {
      reducerName: "MovePlayer",
      argsType: MovePlayer.getTypeScriptAlgebraicType(),
    },
    PlaceBlock: {
      reducerName: "PlaceBlock",
      argsType: PlaceBlock.getTypeScriptAlgebraicType(),
    },
    SpawnEnemy: {
      reducerName: "SpawnEnemy",
      argsType: SpawnEnemy.getTypeScriptAlgebraicType(),
    },
    UpdateAttack: {
      reducerName: "UpdateAttack",
      argsType: UpdateAttack.getTypeScriptAlgebraicType(),
    },
    UpdateWorldTick: {
      reducerName: "UpdateWorldTick",
      argsType: UpdateWorldTick.getTypeScriptAlgebraicType(),
    },
  },
  versionInfo: {
    cliVersion: "1.3.2",
  },
  // Constructors which are used by the DbConnectionImpl to
  // extract type information from the generated RemoteModule.
  //
  // NOTE: This is not strictly necessary for `eventContextConstructor` because
  // all we do is build a TypeScript object which we could have done inside the
  // SDK, but if in the future we wanted to create a class this would be
  // necessary because classes have methods, so we'll keep it.
  eventContextConstructor: (imp: DbConnectionImpl, event: Event<Reducer>) => {
    return {
      ...(imp as DbConnection),
      event
    }
  },
  dbViewConstructor: (imp: DbConnectionImpl) => {
    return new RemoteTables(imp);
  },
  reducersConstructor: (imp: DbConnectionImpl, setReducerFlags: SetReducerFlags) => {
    return new RemoteReducers(imp, setReducerFlags);
  },
  setReducerFlagsConstructor: () => {
    return new SetReducerFlags();
  }
}

// A type representing all the possible variants of a reducer.
export type Reducer = never
| { name: "Attack", args: Attack }
| { name: "ClientConnected", args: ClientConnected }
| { name: "ClientDisconnected", args: ClientDisconnected }
| { name: "CreateWorld", args: CreateWorld }
| { name: "DamageBlock", args: DamageBlock }
| { name: "DamageEnemy", args: DamageEnemy }
| { name: "DamagePlayer", args: DamagePlayer }
| { name: "EnemyShootAtClosestPlayer", args: EnemyShootAtClosestPlayer }
| { name: "InitEnemyTypes", args: InitEnemyTypes }
| { name: "MoveEnemyTowardCore", args: MoveEnemyTowardCore }
| { name: "MovePlayer", args: MovePlayer }
| { name: "PlaceBlock", args: PlaceBlock }
| { name: "SpawnEnemy", args: SpawnEnemy }
| { name: "UpdateAttack", args: UpdateAttack }
| { name: "UpdateWorldTick", args: UpdateWorldTick }
;

export class RemoteReducers {
  constructor(private connection: DbConnectionImpl, private setCallReducerFlags: SetReducerFlags) {}

  attack(enemyId: number, isAttacking: boolean, shootAngle: number) {
    const __args = { enemyId, isAttacking, shootAngle };
    let __writer = new BinaryWriter(1024);
    Attack.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("Attack", __argsBuffer, this.setCallReducerFlags.attackFlags);
  }

  onAttack(callback: (ctx: ReducerEventContext, enemyId: number, isAttacking: boolean, shootAngle: number) => void) {
    this.connection.onReducer("Attack", callback);
  }

  removeOnAttack(callback: (ctx: ReducerEventContext, enemyId: number, isAttacking: boolean, shootAngle: number) => void) {
    this.connection.offReducer("Attack", callback);
  }

  onClientConnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.onReducer("ClientConnected", callback);
  }

  removeOnClientConnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.offReducer("ClientConnected", callback);
  }

  onClientDisconnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.onReducer("ClientDisconnected", callback);
  }

  removeOnClientDisconnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.offReducer("ClientDisconnected", callback);
  }

  createWorld(width: number, height: number) {
    const __args = { width, height };
    let __writer = new BinaryWriter(1024);
    CreateWorld.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("CreateWorld", __argsBuffer, this.setCallReducerFlags.createWorldFlags);
  }

  onCreateWorld(callback: (ctx: ReducerEventContext, width: number, height: number) => void) {
    this.connection.onReducer("CreateWorld", callback);
  }

  removeOnCreateWorld(callback: (ctx: ReducerEventContext, width: number, height: number) => void) {
    this.connection.offReducer("CreateWorld", callback);
  }

  damageBlock(blockId: number, damage: number) {
    const __args = { blockId, damage };
    let __writer = new BinaryWriter(1024);
    DamageBlock.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("DamageBlock", __argsBuffer, this.setCallReducerFlags.damageBlockFlags);
  }

  onDamageBlock(callback: (ctx: ReducerEventContext, blockId: number, damage: number) => void) {
    this.connection.onReducer("DamageBlock", callback);
  }

  removeOnDamageBlock(callback: (ctx: ReducerEventContext, blockId: number, damage: number) => void) {
    this.connection.offReducer("DamageBlock", callback);
  }

  damageEnemy(enemyId: number) {
    const __args = { enemyId };
    let __writer = new BinaryWriter(1024);
    DamageEnemy.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("DamageEnemy", __argsBuffer, this.setCallReducerFlags.damageEnemyFlags);
  }

  onDamageEnemy(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.onReducer("DamageEnemy", callback);
  }

  removeOnDamageEnemy(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.offReducer("DamageEnemy", callback);
  }

  damagePlayer(enemyId: number) {
    const __args = { enemyId };
    let __writer = new BinaryWriter(1024);
    DamagePlayer.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("DamagePlayer", __argsBuffer, this.setCallReducerFlags.damagePlayerFlags);
  }

  onDamagePlayer(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.onReducer("DamagePlayer", callback);
  }

  removeOnDamagePlayer(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.offReducer("DamagePlayer", callback);
  }

  enemyShootAtClosestPlayer(enemyId: number, speed: number) {
    const __args = { enemyId, speed };
    let __writer = new BinaryWriter(1024);
    EnemyShootAtClosestPlayer.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("EnemyShootAtClosestPlayer", __argsBuffer, this.setCallReducerFlags.enemyShootAtClosestPlayerFlags);
  }

  onEnemyShootAtClosestPlayer(callback: (ctx: ReducerEventContext, enemyId: number, speed: number) => void) {
    this.connection.onReducer("EnemyShootAtClosestPlayer", callback);
  }

  removeOnEnemyShootAtClosestPlayer(callback: (ctx: ReducerEventContext, enemyId: number, speed: number) => void) {
    this.connection.offReducer("EnemyShootAtClosestPlayer", callback);
  }

  initEnemyTypes() {
    this.connection.callReducer("InitEnemyTypes", new Uint8Array(0), this.setCallReducerFlags.initEnemyTypesFlags);
  }

  onInitEnemyTypes(callback: (ctx: ReducerEventContext) => void) {
    this.connection.onReducer("InitEnemyTypes", callback);
  }

  removeOnInitEnemyTypes(callback: (ctx: ReducerEventContext) => void) {
    this.connection.offReducer("InitEnemyTypes", callback);
  }

  moveEnemyTowardCore(enemyId: number) {
    const __args = { enemyId };
    let __writer = new BinaryWriter(1024);
    MoveEnemyTowardCore.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("MoveEnemyTowardCore", __argsBuffer, this.setCallReducerFlags.moveEnemyTowardCoreFlags);
  }

  onMoveEnemyTowardCore(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.onReducer("MoveEnemyTowardCore", callback);
  }

  removeOnMoveEnemyTowardCore(callback: (ctx: ReducerEventContext, enemyId: number) => void) {
    this.connection.offReducer("MoveEnemyTowardCore", callback);
  }

  movePlayer(playerId: number, newX: number, newY: number) {
    const __args = { playerId, newX, newY };
    let __writer = new BinaryWriter(1024);
    MovePlayer.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("MovePlayer", __argsBuffer, this.setCallReducerFlags.movePlayerFlags);
  }

  onMovePlayer(callback: (ctx: ReducerEventContext, playerId: number, newX: number, newY: number) => void) {
    this.connection.onReducer("MovePlayer", callback);
  }

  removeOnMovePlayer(callback: (ctx: ReducerEventContext, playerId: number, newX: number, newY: number) => void) {
    this.connection.offReducer("MovePlayer", callback);
  }

  placeBlock(x: number, y: number, health: number, width: number, height: number) {
    const __args = { x, y, health, width, height };
    let __writer = new BinaryWriter(1024);
    PlaceBlock.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("PlaceBlock", __argsBuffer, this.setCallReducerFlags.placeBlockFlags);
  }

  onPlaceBlock(callback: (ctx: ReducerEventContext, x: number, y: number, health: number, width: number, height: number) => void) {
    this.connection.onReducer("PlaceBlock", callback);
  }

  removeOnPlaceBlock(callback: (ctx: ReducerEventContext, x: number, y: number, health: number, width: number, height: number) => void) {
    this.connection.offReducer("PlaceBlock", callback);
  }

  spawnEnemy(typeId: number, posX: number, posY: number, difficultyMultiplier: number) {
    const __args = { typeId, posX, posY, difficultyMultiplier };
    let __writer = new BinaryWriter(1024);
    SpawnEnemy.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("SpawnEnemy", __argsBuffer, this.setCallReducerFlags.spawnEnemyFlags);
  }

  onSpawnEnemy(callback: (ctx: ReducerEventContext, typeId: number, posX: number, posY: number, difficultyMultiplier: number) => void) {
    this.connection.onReducer("SpawnEnemy", callback);
  }

  removeOnSpawnEnemy(callback: (ctx: ReducerEventContext, typeId: number, posX: number, posY: number, difficultyMultiplier: number) => void) {
    this.connection.offReducer("SpawnEnemy", callback);
  }

  updateAttack(playerId: number, isFiring: boolean, attackAngle: number) {
    const __args = { playerId, isFiring, attackAngle };
    let __writer = new BinaryWriter(1024);
    UpdateAttack.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("UpdateAttack", __argsBuffer, this.setCallReducerFlags.updateAttackFlags);
  }

  onUpdateAttack(callback: (ctx: ReducerEventContext, playerId: number, isFiring: boolean, attackAngle: number) => void) {
    this.connection.onReducer("UpdateAttack", callback);
  }

  removeOnUpdateAttack(callback: (ctx: ReducerEventContext, playerId: number, isFiring: boolean, attackAngle: number) => void) {
    this.connection.offReducer("UpdateAttack", callback);
  }

  updateWorldTick(timer: WorldTickUpdateTimer) {
    const __args = { timer };
    let __writer = new BinaryWriter(1024);
    UpdateWorldTick.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("UpdateWorldTick", __argsBuffer, this.setCallReducerFlags.updateWorldTickFlags);
  }

  onUpdateWorldTick(callback: (ctx: ReducerEventContext, timer: WorldTickUpdateTimer) => void) {
    this.connection.onReducer("UpdateWorldTick", callback);
  }

  removeOnUpdateWorldTick(callback: (ctx: ReducerEventContext, timer: WorldTickUpdateTimer) => void) {
    this.connection.offReducer("UpdateWorldTick", callback);
  }

}

export class SetReducerFlags {
  attackFlags: CallReducerFlags = 'FullUpdate';
  attack(flags: CallReducerFlags) {
    this.attackFlags = flags;
  }

  createWorldFlags: CallReducerFlags = 'FullUpdate';
  createWorld(flags: CallReducerFlags) {
    this.createWorldFlags = flags;
  }

  damageBlockFlags: CallReducerFlags = 'FullUpdate';
  damageBlock(flags: CallReducerFlags) {
    this.damageBlockFlags = flags;
  }

  damageEnemyFlags: CallReducerFlags = 'FullUpdate';
  damageEnemy(flags: CallReducerFlags) {
    this.damageEnemyFlags = flags;
  }

  damagePlayerFlags: CallReducerFlags = 'FullUpdate';
  damagePlayer(flags: CallReducerFlags) {
    this.damagePlayerFlags = flags;
  }

  enemyShootAtClosestPlayerFlags: CallReducerFlags = 'FullUpdate';
  enemyShootAtClosestPlayer(flags: CallReducerFlags) {
    this.enemyShootAtClosestPlayerFlags = flags;
  }

  initEnemyTypesFlags: CallReducerFlags = 'FullUpdate';
  initEnemyTypes(flags: CallReducerFlags) {
    this.initEnemyTypesFlags = flags;
  }

  moveEnemyTowardCoreFlags: CallReducerFlags = 'FullUpdate';
  moveEnemyTowardCore(flags: CallReducerFlags) {
    this.moveEnemyTowardCoreFlags = flags;
  }

  movePlayerFlags: CallReducerFlags = 'FullUpdate';
  movePlayer(flags: CallReducerFlags) {
    this.movePlayerFlags = flags;
  }

  placeBlockFlags: CallReducerFlags = 'FullUpdate';
  placeBlock(flags: CallReducerFlags) {
    this.placeBlockFlags = flags;
  }

  spawnEnemyFlags: CallReducerFlags = 'FullUpdate';
  spawnEnemy(flags: CallReducerFlags) {
    this.spawnEnemyFlags = flags;
  }

  updateAttackFlags: CallReducerFlags = 'FullUpdate';
  updateAttack(flags: CallReducerFlags) {
    this.updateAttackFlags = flags;
  }

  updateWorldTickFlags: CallReducerFlags = 'FullUpdate';
  updateWorldTick(flags: CallReducerFlags) {
    this.updateWorldTickFlags = flags;
  }

}

export class RemoteTables {
  constructor(private connection: DbConnectionImpl) {}

  get block(): BlockTableHandle {
    return new BlockTableHandle(this.connection.clientCache.getOrCreateTable<Block>(REMOTE_MODULE.tables.Block));
  }

  get enemy(): EnemyTableHandle {
    return new EnemyTableHandle(this.connection.clientCache.getOrCreateTable<Enemy>(REMOTE_MODULE.tables.Enemy));
  }

  get enemyType(): EnemyTypeTableHandle {
    return new EnemyTypeTableHandle(this.connection.clientCache.getOrCreateTable<EnemyType>(REMOTE_MODULE.tables.EnemyType));
  }

  get player(): PlayerTableHandle {
    return new PlayerTableHandle(this.connection.clientCache.getOrCreateTable<Player>(REMOTE_MODULE.tables.Player));
  }

  get world(): WorldTableHandle {
    return new WorldTableHandle(this.connection.clientCache.getOrCreateTable<World>(REMOTE_MODULE.tables.World));
  }

  get worldTickUpdateTimer(): WorldTickUpdateTimerTableHandle {
    return new WorldTickUpdateTimerTableHandle(this.connection.clientCache.getOrCreateTable<WorldTickUpdateTimer>(REMOTE_MODULE.tables.WorldTickUpdateTimer));
  }
}

export class SubscriptionBuilder extends SubscriptionBuilderImpl<RemoteTables, RemoteReducers, SetReducerFlags> { }

export class DbConnection extends DbConnectionImpl<RemoteTables, RemoteReducers, SetReducerFlags> {
  static builder = (): DbConnectionBuilder<DbConnection, ErrorContext, SubscriptionEventContext> => {
    return new DbConnectionBuilder<DbConnection, ErrorContext, SubscriptionEventContext>(REMOTE_MODULE, (imp: DbConnectionImpl) => imp as DbConnection);
  }
  subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  }
}

export type EventContext = EventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags, Reducer>;
export type ReducerEventContext = ReducerEventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags, Reducer>;
export type SubscriptionEventContext = SubscriptionEventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags>;
export type ErrorContext = ErrorContextInterface<RemoteTables, RemoteReducers, SetReducerFlags>;
